import React from 'react';
import { AlertTriangle, CloudSnow, Wind, Snowflake } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
const alerts = [{
  id: 1,
  type: 'warning',
  title: 'Alerte neige forte',
  description: 'Accumulation de 10-15 cm prévue',
  startTime: new Date(Date.now() + 2 * 60 * 60 * 1000),
  severity: 'high',
  icon: CloudSnow
}, {
  id: 2,
  type: 'advisory',
  title: 'Avertissement de vent',
  description: "Rafales jusqu'à 40 km/h",
  startTime: new Date(Date.now() + 4 * 60 * 60 * 1000),
  severity: 'medium',
  icon: Wind
}, {
  id: 3,
  type: 'watch',
  title: 'Veille verglas',
  description: 'Conditions favorables au verglas',
  startTime: new Date(Date.now() + 24 * 60 * 60 * 1000),
  severity: 'low',
  icon: Snowflake
}];
export function WeatherAlerts() {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-652">
      <div className="p-6 border-b border-gray-200" data-id="element-653">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-654">Alertes météo</h2>
        <p className="text-sm text-gray-600 mt-1" data-id="element-655">
          {alerts.length} alertes actives
        </p>
      </div>
      <div className="divide-y divide-gray-200" data-id="element-656">
        {alerts.map(alert => {
        const Icon = alert.icon;
        return <div key={alert.id} className="p-4 hover:bg-gray-50 transition-colors" data-id="element-657">
              <div className="flex items-start space-x-3" data-id="element-658">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${alert.severity === 'high' ? 'bg-red-100' : alert.severity === 'medium' ? 'bg-orange-100' : 'bg-yellow-100'}`} data-id="element-659">
                  <Icon className={`w-5 h-5 ${alert.severity === 'high' ? 'text-red-600' : alert.severity === 'medium' ? 'text-orange-600' : 'text-yellow-600'}`} data-id="element-660" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-661">
                  <div className="flex items-center space-x-2" data-id="element-662">
                    <h3 className="text-sm font-semibold text-gray-900" data-id="element-663">
                      {alert.title}
                    </h3>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${alert.severity === 'high' ? 'bg-red-100 text-red-700' : alert.severity === 'medium' ? 'bg-orange-100 text-orange-700' : 'bg-yellow-100 text-yellow-700'}`} data-id="element-664">
                      {alert.severity === 'high' ? 'Urgent' : alert.severity === 'medium' ? 'Important' : 'Veille'}
                    </span>
                  </div>
                  <p className="text-xs text-gray-600 mt-1" data-id="element-665">
                    {alert.description}
                  </p>
                  <p className="text-xs text-gray-500 mt-2" data-id="element-666">
                    Début:{' '}
                    {format(alert.startTime, 'dd MMM à HH:mm', {
                  locale: fr
                })}
                  </p>
                </div>
              </div>
            </div>;
      })}
      </div>
      <div className="p-4 border-t border-gray-200" data-id="element-667">
        <button className="w-full px-4 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" data-id="element-668">
          Voir toutes les alertes
        </button>
      </div>
    </div>;
}